import { API_CONFIG } from '@/config/apiConfig';
import { apiClient } from './client';

const isAbortError = (error) => error?.name === 'CanceledError' || error?.name === 'AbortError';

export const getFormConfig = async (formGuid, signal) => {
  try {
    const endpoint = API_CONFIG.endpoints.getFormConfig(formGuid);
    const response = await apiClient.get(endpoint, { signal });
    return { success: true, data: response.data };
  } catch (error) {
    if (isAbortError(error)) {
      throw error;
    }
    return { success: false, error: 'Failed to fetch form configuration' };
  }
};

export const getSiteConfig = async (formGuid, signal) => {
  try {
    const endpoint = API_CONFIG.endpoints.getSiteConfig(formGuid);
    const response = await apiClient.get(endpoint, { signal });
    return { success: true, data: response.data };
  } catch (error) {
    if (isAbortError(error)) {
      throw error;
    }
    return { success: false, error: 'Failed to fetch site configuration' };
  }
};
